<template>
  <div class="labor-cost">
    <div class="search">
      <el-form ref="searchForm" :model="searchForm" label-width="80px">
        <el-form-item label="仓库：" prop="warehouseId" class="customer-form">
          <el-select 
            class="white"
            clearable
            v-model="searchForm.warehouseId"
            placeholder="请选择仓库"
          >
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期：" prop="date">
          <el-date-picker
            v-model="searchForm.date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-button class="btn-blue" @click="search">搜索</el-button>
        <el-button class="btn-white" @click="resetForm('searchForm')">清空</el-button>
      </el-form>
      <div class="operation-btn">
        <el-button
          class="btn-white entry"
          icon="el-icon-download"
          @click="openEntry"
          >录入</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table ref="table" :data="tableData" style="width: 100%">
        <el-table-column
          v-for="(item, index) in tableTitleList"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
          :min-width="item.width"
        ></el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @queryChange="queryChange"
        ></pagination-tpl>
      </div>
    </div>

    
    <!-- 录入 -->
    <el-dialog
      title="录入"
      top="12vh"
      :visible.sync="dialog"
      width="600px"
      :close-on-click-modal="false"
      :before-close="closeDialog"
      class="entry-dialog"
    >
      <el-form class="entry-form" ref="entryForm" :model="entryForm" :rules="rules">
        <el-form-item label="仓库" prop="warehouseId">
          <el-select 
            class="white"
            clearable
            v-model="entryForm.warehouseId"
            placeholder="请选择仓库"
          >
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期" prop="date">
          <el-date-picker
            v-model="entryForm.date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            clearable
          ></el-date-picker>
        </el-form-item>
        <div class="title">人工成本信息</div>
        <div class="labor-info">
          <div class="labor-info-left">
            <el-form-item label="临时工人数" prop="temporaryWorkerNums">
              <el-input
                class="gray white"
                v-model="entryForm.temporaryWorkerNums"
                placeholder="请输入"
                clearable
                @input="temporaryWorkerNumsInput(entryForm.temporaryWorkerNums)"
              ></el-input>
            </el-form-item>
            <el-form-item label="临时工总工时" prop="temporaryWorkerTime">
              <el-input
                class="gray white"
                v-model="entryForm.temporaryWorkerTime"
                placeholder="请输入"
                clearable
                @input="temporaryWorkerTimeInput(entryForm.temporaryWorkerTime)"
              ></el-input>
            </el-form-item>
            <el-form-item label="临时工工资" prop="temporaryWorkerSarlay">
              <el-input
                class="gray white"
                v-model="entryForm.temporaryWorkerSarlay"
                placeholder="请输入"
                clearable
                @input="temporaryWorkerSarlayInput(entryForm.temporaryWorkerSarlay)"
              ></el-input>
            </el-form-item>
          </div>
          <div class="labor-info-right">
            <el-form-item label="正式工人数" prop="formalWorkerNums">
              <el-input
                class="gray white"
                v-model="entryForm.formalWorkerNums"
                placeholder="请输入"
                clearable
                @input="formalWorkerNumsInput(entryForm.formalWorkerNums)"
              ></el-input>
            </el-form-item>
            <el-form-item label="正式工总工时" prop="formalWorkerTime">
              <el-input
                class="gray white"
                v-model="entryForm.formalWorkerTime"
                placeholder="请输入"
                clearable
                @input="formalWorkerTimeInput(entryForm.formalWorkerTime)"
              ></el-input>
            </el-form-item>
            <el-form-item label="正式工工资" prop="formalWorkerSarlay">
              <el-input
                class="gray white"
                v-model="entryForm.formalWorkerSarlay"
                placeholder="请输入"
                clearable
                @input="formalWorkerSarlayInput(entryForm.formalWorkerSarlay)"
              ></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="confirm('entryForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PaginationTpl from "components/base/PaginationTpl";
import Expenses from "models/expenses";
const expenses = new Expenses();
import LaborCost from "models/data-entry/labor-cost";
import { inputAllTwoDecimal, getInteger } from "common/js/util";
export default {
  components: {
    PaginationTpl
  },

  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitleList: [
        {label: '日期', prop: 'createTime', width: '150'},
        {label: '仓库', prop: 'warehouseName', width: ''},
        {label: '临时工人数', prop: 'temporaryWorkerNums', width: ''},
        {label: '临时工总工时', prop: 'temporaryWorkerTime', width: ''},
        {label: '临时工工资', prop: 'temporaryWorkerSarlay', width: ''},
        {label: '正式工人数', prop: 'formalWorkerNums', width: ''},
        {label: '正式工总工时', prop: 'formalWorkerTime', width: ''},
        {label: '正式工工资', prop: 'formalWorkerSarlay', width: ''},
      ],
      warehouseList: [],
      searchForm: {
        warehouseId: '',
        date: ''
      },
      
      dialog: false,
      entryForm: {
        warehouseId: '',
        date: '',
        temporaryWorkerNums: null,
        temporaryWorkerTime: null,
        temporaryWorkerSarlay: null,
        formalWorkerNums: null,
        formalWorkerTime: null,
        formalWorkerSarlay: null,
      },
      rules: {
        warehouseId: [
          { required: true, message: '请选择仓库', trigger: 'change' }
        ],
        date: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ]
      },
    }
  },

  created() {
    this.initList()
    this.getWarehouseList()
  },

  methods: {
    //获取仓库数据
    getWarehouseList() {
      expenses.getWarehouseData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouseList = arr;
        }
      });
    },
    
    initList() {
      let currentPage = this.currentPage
      let warehouseId = this.searchForm.warehouseId
      let reportDate = this.searchForm.date
      let data = {
        currentPage,
        warehouseId,
        reportDate
      }
      LaborCost.getLaborCostList(data).then(res => {
        if (res.success) {
          let arr = []
          this.total = res.result.totalNum
          this.pageSize = res.result.pageSize
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.createTime = i.reportDate
            obj.warehouseName = i.warehouseName
            obj.temporaryWorkerNums = i.tempEmployeeQuantity
            obj.temporaryWorkerTime = i.tempEmployeeHours
            obj.temporaryWorkerSarlay = i.tempEmployeeAmount
            obj.formalWorkerNums = i.regularEmployeeQuantity
            obj.formalWorkerTime = i.regularEmployeeHours
            obj.formalWorkerSarlay = i.regularEmployeeAmount
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initList();
    },

    search() {
      this.currentPage = 1
      this.initList();
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    openEntry() {
      this.dialog = true
    },

    closeDialog() {
      this.entryForm.warehouseId = ''
      this.entryForm.date = ''
      this.entryForm.temporaryWorkerNums = null
      this.entryForm.temporaryWorkerTime = null
      this.entryForm.temporaryWorkerSarlay = null
      this.entryForm.formalWorkerNums = null
      this.entryForm.formalWorkerTime = null
      this.entryForm.formalWorkerSarlay = null
      this.dialog = false
    },

    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let warehouseId = this.entryForm.warehouseId
          let billDate = this.entryForm.date
          let tempNum = Number(this.entryForm.temporaryWorkerNums)
          let tempHours = this.entryForm.temporaryWorkerTime
          let tempCost = this.entryForm.temporaryWorkerSarlay
          let regularNum = Number(this.entryForm.formalWorkerNums)
          let regularHours = this.entryForm.formalWorkerTime
          let regularCost = this.entryForm.formalWorkerSarlay
          let data = {
            warehouseId,
            billDate,
            tempNum,
            tempHours,
            tempCost,
            regularNum,
            regularHours,
            regularCost,
          }
          LaborCost.postEntryLaborCost(data).then(res => {
            if (res.success) {
              this.initList()
              this.closeDialog()
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    temporaryWorkerNumsInput(v) {
      this.entryForm.temporaryWorkerNums = getInteger(v);
    },
    temporaryWorkerTimeInput(v) {
      this.entryForm.temporaryWorkerTime = inputAllTwoDecimal(v);
    },
    temporaryWorkerSarlayInput(v) {
      this.entryForm.temporaryWorkerSarlay = inputAllTwoDecimal(v);
    },
    formalWorkerNumsInput(v) {
      this.entryForm.formalWorkerNums = getInteger(v);
    },
    formalWorkerTimeInput(v) {
      this.entryForm.formalWorkerTime = inputAllTwoDecimal(v);
    },
    formalWorkerSarlayInput(v) {
      this.entryForm.formalWorkerSarlay = inputAllTwoDecimal(v);
    }
  }
}
</script>

<style lang='scss'>
.labor-cost {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  box-sizing: border-box;
  .search {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 16px;
    padding: 0px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    .btn-blue,
    .btn-gray {
      margin-left: 16px;
    }
    .entry {
      padding: 0px 14px;
    }
    .el-form {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 72px;
      .el-form-item {
        margin-bottom: 0px;
      }
      .customer-form {
        .el-form-item__label {
          width: 50px!important;
        }
        .el-form-item__content {
          margin-left: 50px!important;
        }
      }
    }
  }
  .table {
    padding: 16px;
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }

  .entry-dialog {
    .el-dialog__header {
      border-bottom: 1px solid #eee;
      margin-bottom: 16px;
    }
    .entry-form {
      .el-form-item {
        .el-form-item__label {
          width: 100%;
          text-align: left;
        }
        .el-form-item__content,
        .el-select,
        .el-date-editor {
          width: 100%;
        }
      }
      .title {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        margin-bottom: 10px;
      }
      .labor-info {
        padding: 20px;
        display: flex;
        justify-content: flex-start;
        border: 1px solid #eee;
        &-left {
          width: 50%;
          margin-right: 30px;
        }
        &-right {
          width: 50%;
        }
      }
    }
    .el-dialog__footer {
      padding: 0px;
      .dialog-footer {
        border-top: 1px solid #eee;
        padding-top: 16px;
        padding-bottom: 16px;
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
